import './style.scss';
import {
  Button,
  DropdownMenu,
  QuickMenuIcon,
  useToastContext,
} from '@trufla-technology/trumarket-react-design-system';
import { ListProductDefinitions } from '@trufla-technology/trufla-trudomain/dist/lib/truMarket/types';
import { useHistory } from 'react-router-dom';
import {
  useListRequestDefinitions,
  useUnassignRequestDefinitionsFromTeams,
} from '@trufla-technology/trufla-trudomain/dist/lib/truMarket';
import { IErrorResponse } from 'app/types/ErrorResponse';
import { useAuthContext } from '@trufla-technology/trufla-trudomain/dist/lib';

interface IProps {
  data: ListProductDefinitions[number];
  teamKey: string;
  getProducts: () => void;
}
export const ProductsCard = ({ data, teamKey, getProducts }: IProps) => {
  const { isPermitted } = useAuthContext();
  const history = useHistory();
  const toaster = useToastContext();
  const { data: savedRequests } = useListRequestDefinitions({
    filter: {
      productDefinitionKey: data.key || '',
      teamKeys: [teamKey],
    },
    paginate: { offset: 0, limit: 100 },
  });
  const UnassignRequestDefinitionsFromTeams =
    useUnassignRequestDefinitionsFromTeams();
  const handleUnAssignRequestesInProducts = async () => {
    try {
      if (savedRequests && savedRequests.length) {
        await UnassignRequestDefinitionsFromTeams({
          unassigning: [
            ...savedRequests?.map((x) => {
              return {
                teamKey: teamKey,
                requestDefinitionKey: x.key || '',
              };
            }),
          ],
        });
        await getProducts();
      }
    } catch (err: unknown) {
      const errorMessage = (
        err as IErrorResponse
      )?.response?.data?.error.replaceAll('body.', '');
      toaster.error(errorMessage || `Error!, please try again.`);
    }
  };
  return (
    <div className="product-card">
      <div className="product-icon">
        {data.name && data.name.substring(0, 2)}
      </div>
      <div className="product-info">
        <h2 className="product-name">{data.name}</h2>
        <p className="product-branch">{data.description}</p>
      </div>
      <div className="product-actions">
        <p>{savedRequests && savedRequests.length} Requests</p>
        <div className="product-dropdown-actions">
          <DropdownMenu
            items={
              <div className="product-buttons">
                <Button
                  type="link"
                  classes="configure-product"
                  onClick={() =>
                    history.push({
                      search: `assign-requests=${data.key}&name=${data.name}`,
                    })
                  }
                >
                  Configure
                </Button>
                {isPermitted('deleteNotification') && (
                  <Button
                    type="link"
                    classes="remove-product"
                    onClick={() => handleUnAssignRequestesInProducts()}
                  >
                    Remove
                  </Button>
                )}
              </div>
            }
            openLeft
          >
            <QuickMenuIcon width="4px" />
          </DropdownMenu>
        </div>
      </div>
    </div>
  );
};
